/* ==========================================================================
   ModalSearcher > Client
   ========================================================================== */

/* Import modules */
const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');

const ModalClient = require('@bluekiri/alexandria-contrib-components/components/modal/client/js');

const config = require('./config');
const prototype = require('./prototype');

/**
 * ModalSearcher component
 * @param {selector} String selector for the component in the client side.
 */
module.exports = function ModalSearcher(selector = '[data-component=Modal]', configuration = {}) {
    if (elementExist(selector)) {
        // Instance reference
        const instance = Object.create(prototype);

        // Config
        instance.config = { ...config(), ...configuration };

        // Element reference
        instance.element = document.querySelector(selector);

        // Init modal
        instance.modal = ModalClient(selector, {
            ...configuration,
            autoStore: false,
            onOpen: () => {
                instance.onOpen();
            },
            onClose: () => {
                instance.onClose();
            }
        });

        /* Hooks */
        instance.hooks = {
            title: instance.element.querySelector('[data-title]'),
            productSearcher: instance.element.querySelector('[data-product-searcher]'),
            product: instance.element.querySelector('[data-product]'),
            price: instance.element.querySelector('[data-component="Price"]'),
            searcher: instance.element.querySelector('[data-searcher]')
        };

        instance.config.context = JSON.parse(instance.hooks.productSearcher.dataset.config).context;
        instance.hooks.productSearcher.removeAttribute('config');

        if (instance.config.init) instance.init();

        return instance;
    }
};
